package one.healthium.ui.compose.utils

import androidx.compose.ui.graphics.Color

fun Long.toColor() = Color(this)